import CacheBase2 from '../../../services/engines/CacheBase2';

/**
 * Holds UmlPkgLib notes (cached package templates).
 */
class UmlPkgLibCache extends CacheBase2 {
    initialize() {
        this._name = 'UmlPkgLibCache';
    }
}

const umlPkgLibCache = new UmlPkgLibCache();
export default umlPkgLibCache;
